<template>
  <div class="DataUpdate">
    <modal
      name="ProgramModal"
      width="80%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      style="overflow: scroll"
    >
      <div class="tabcontent" >
        <ValidationObserver ref="obsFieldsUpdate">
          <FormupdatePeriods
            :FieldsForm="formUpdate"
            :ModelForm="formUpdModel"
            :method="executeProcess"
            v-if="renderComponent2"
          />
        </ValidationObserver>
        <div class="botonPnrocess">
          <div class="container">
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-2" v-if="isNew === false">
                <button
                  id="updatePeriod"
                  type="submit"
                  v-on:click="updatePeriod"
                  class="loginbtn primaryBtn"
                >
                  Actualizar
                </button>
              </div>
              <div class="col-md-2" v-else-if="isNew === true">
                <button
                  id="AddProgram"
                  type="submit"
                  v-on:click="AddProgram"
                  class="loginbtn primaryBtn"
                >
                  Guardar
                </button>
              </div>
              <div class="col-md-2">
                <button
                  id="CancelUser"
                  type="submit"
                  v-on:click="CancelUser"
                  class="loginbtn primaryBtn"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </modal>

    <div class="titlePage">Administración - Periodos Ibero</div>
 <div style="height: 5rem;"></div>
      <div  v-if=" this.EditF == true">
         <p class="h1">Consultar y Editar</p>
      </div>

       <div  v-if=" this.CreateF == true">
         <p class="h1">Crear Permanencia</p>
      </div>

    <va-notification color="info" v-if="addRExito" class="refNoData"
      >Se creo correctamente el programa solicitado.</va-notification
    >
    <va-notification color="info" v-if="UpdRExito" class="refNoData"
      >Se actualizo correctamente el programa solicitado.</va-notification
    >
    <va-notification color="danger" v-if="refNoUpdate" class="refNoData"
      >La actualizacion del programa presento un fallo.</va-notification
    >
    <va-notification color="danger" v-if="refWSUpdate" class="refNoData"
      >El servicio que ejecuta la actualización no se encuentra
      activo.</va-notification
    >
     <va-notification color="ErrorDatos" v-if="refWSUpdate" class="refNoData"
      >Por favor ingrese Convenio
      activo.</va-notification
    >

    <ValidationObserver ref="obsFieldsSearch">
      <FormSearchProgram
        :FieldsForm="formSearch"
        :ModelForm="formSchModel"
        :method="executeProcess"
      />
    </ValidationObserver>
    <va-notification color="danger" id="refNoData" class="refNoData noShow"
      >No se encontró información del programa solicitado.</va-notification
    >
    <div class="listPrograms" >
      <DataTablePrograms
        :InfoView="this.DLPrograms"
        :HeadTable="this.HDProgram"
        :method="processData"
        v-if="renderComponent1"
      />
    </div>

<div class="container" v-if="form1 == false" >
  <div class="row">
    <div class="col-xs-12 col-md-3">
      <div class="form-group">
        <label for="">  </label>
        <div class="input-group">
          <button
          type="button" class="btn btn-success"
          style="height: 3rem;"
          v-on:click="showPerm"
          >Consultar y Editar
          </button>
          <span class="input-group-addon">-</span>
          <button
            type="button" class="btn"
            style="height: 3rem;"
            v-on:click="showform"
            >Insertar Permanencia
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

  <div>
  <label class="typo__label">Periodo Banner</label>
  <multiselect v-model="value" deselect-label="Can't remove this value" @input="BuscarPeriodo"
  track-by="value" label="value" placeholder="Select one"
  :options="options" :searchable="false" :allow-empty="false">
  <template slot="singleLabel" slot-scope="{ option }"   >
  <strong > {{ option.value }}  </strong></template>
  </multiselect>
</div>

<div >
  <label class="typo__label">Periodo Anterior</label>

  <multiselect v-model="value2" deselect-label="Can't remove this value"  @input="BuscarPeriodoNext"
  track-by="period" label="period" placeholder="Select one" :options="options2"
    :searchable="false" :allow-empty="false">
    <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.period}}
    </strong></template>
  </multiselect>
</div>

 <div>
  <label class="typo__label">Convenio</label>
  <multiselect v-model="value3" deselect-label="Can't remove this value"    @input="NewPeriod"
   track-by="operator" label="operator" placeholder="Select one" :options="options3"
    :searchable="false" :allow-empty="false">
    <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.operator}}
    </strong></template>
  </multiselect>
 </div>
    <div style="height: 4rem;"></div>
 </div>

</template>

<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchProgram from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormupdatePeriods from '@/components/forms/Forms.vue'

import Multiselect from 'vue-multiselect'
import IberoHelpers from '@/store/helpers.js'
import DataTablePrograms from '@/components/data-tables/DataPermanence.vue'

import Vue from 'vue'
import { DateTimePickerPlugin } from '@syncfusion/ej2-vue-calendars'
Vue.use(DateTimePickerPlugin)

export default {
  name: 'DataUpdate',
  components: {
    DataTablePrograms,
    FormSearchProgram,
    FormupdatePeriods,
    Multiselect,
  },
  data () {
    return {

      BannerList: IberoHelpers.getPermanence(this.$store),
      isShowing: false,
      Ids: '',
      idupdate: '',
      Idprog: '',
      muneList: '',
      form1: true,
      CancelOption: '',

      // Solo data multiselect
      selected: null,
      value: null,
      options: this.$store.state.PermanenceList,
      value2: null,
      options2: [],
      value3: null,
      options3: [],

      formSchModel: {},

      formSearch: [
        // {
        //   id: 'Sch_Button',
        //   type: 'button',
        //   placeholder: 'Consultar Permanencia',
        //   class: 'col-md-2',
        // },
      ],

      formUpdModel: {
        id: '',
        programa: '',
        codigO_PROGRAMA: '',
        periodobanner: '',
        iD_CALENDAR_PERMANENCIA: '',
        iD_CALENDAR_PERMANENCIA_PROGRAM: '',
        renovacioN_ANTICIPADA: '',
        staActive: '',
      },

      formUpdate: [
        {
          id: 'programa',
          model: 'programa',
          valores: true,
          name: 'Programa',
          type: 'input',
          placeholder: 'Programa',
          values: '',
          validate: {

            regex: '^([a-zA-z]?)',
            max: 100,
          },
          class: 'col-md-6',
        },

        {
          id: 'renovacioN_ANTICIPADA',
          model: 'renovacioN_ANTICIPADA',
          name: 'RENOVACION ANTICIPADA',
          type: 'input',
          placeholder: 'RENOVACION ANTICIPADA',
          values: 0,
          validate: {
            required: true,
            regex: '^([a-zA-z]?)',
            max: 7,
          },
          class: 'col-md-2',
        },

        {
          id: 'staActive',
          model: 'staActive',
          name: 'Estado',
          type: 'Select',
          placeholder: 'Seleccionar...',
          class: 'col-md-2',
          values: [
            { id: 1, value: 'Activos' },
            { id: 0, value: 'Inactivo' },
          ],
          validate: {
            required: true,
          },
        },
        {
          id: 'iD_CALENDAR_PERMANENCIA',
          model: 'iD_CALENDAR_PERMANENCIA',
          valores: true,
          name: 'CALENDAR PERMANENCIA',
          type: 'input',
          placeholder: 'CALENDAR PERMANENCIA',
          values: '',
          validate: {
            required: true,
            regex: '^([a-zA-z]?)',
            max: 100,
          },
          class: 'col-md-2',
        },
        // {
        //   id: 'iD_CALENDAR_PERMANENCIA_PROGRAM',
        //   model: 'iD_CALENDAR_PERMANENCIA_PROGRAM',
        //   valores: true,
        //   name: 'CALENDAR PERMANENCIA PROGRAM',
        //   type: 'input',
        //   placeholder: 'CALENDAR PERMANENCIA PROGRAM',
        //   values: '',
        //   validate: {

        //     regex: '^([a-zA-z]?)',
        //     max: 100,
        //   },
        //   class: 'col-md-4',
        // },
      ],

      HDProgram: [
        // {
        //   name: 'id',
        //   title: 'ID',
        //   width: '10%',
        // },
        {
          name: 'programa',
          title: 'CODIGO PROGRAMA',
          sortField: 'programa',
          width: '10%',
        },

        {
          name: 'codigO_PROGRAMA',
          title: 'PROGRAMA',
          sortField: 'codigO_PROGRAMA',
          width: '55%',
        },
        {
          name: 'periodbanner',
          title: 'Periodo Banner',
          sortField: 'periodbanner',
          width: '15%',
        },

        {
          name: 'renovacioN_ANTICIPADA',
          title: 'RENOVACION ANTICIPADA',
          sortField: 'renovacioN_ANTICIPADA',
          width: '30%',
        },
        {
          name: 'periodBack',
          title: 'Periodo Anterior',
          sortField: 'periodBack',
          width: '15%',
        },
        {
          name: 'Convenio',
          title: 'Convenio',
          sortField: 'Convenio',
          width: '20%',
        },
        {
          name: '__slot:staActive',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
      ],
      DLPrograms: [],
      renderComponent1: false,
      renderComponent2: false,
      addRExito: false,
      UpdRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      isNew: false,
      isNew2: false,
      CreateF: false,
      EditF: false,
    }
  },

  methods: {

    showform () {
      debugger
      this.searchForm()
      this.CreateF = true
      this.EditF = false
    },

    showPerm () {
      this.isNew = false
      this.form1 = false
      this.CreateF = false
      this.EditF = true
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsSearch.validate().then((results) => {
          if (!results) {
            resolve(false)
          } else {
            this.searchFormpermanence()
            resolve(true)
          }
        })
      })
    },

    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'btn_Sch_Button':
          this.isNew = false
          this.form1 = false
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsSearch.validate().then((results) => {
              if (!results) {
                resolve(false)
              } else {
                this.searchFormpermanence()
                resolve(true)
              }
            })
          })
      }
      this.$refs.obsFieldsSearch.validate()
    },

    searchForm () {
      debugger
      var PBack
      this.isNew2 = false
      // if (this.value.value !== null & this.Ids === '') { PBack = this.value.id }
      // else if (this.value2.period !== null & this.value.value !== null & this.Ids === '2') { PBack = this.value2.id }
      if (this.Ids === '3') {
        var banr = this.value.value.toString()
        var back = this.value2.period.toString()
        var cstudy = this.value3.operator
        PBack = back + '/' + banr + '/' + cstudy
      }
      this.Idprog = PBack
      document.getElementById('refNoData').classList.add('noShow')
      this.isNew = false
      let loader = this.$loading.show()
      var ListgetgetPermanence = IberoHelpers.getPermanenceByIdPeriod(
        this.$store,
        PBack,
        0
      )
      this.renderComponent1 = false

      ListgetgetPermanence.then((Response) => {
        if (Response.data === undefined || Response.data === '') {
          document.getElementById('refNoData').classList.remove('noShow')
        } else {
          debugger
          if (Array.isArray(Response.data)) {
            for (let index = 0; index < Response.data.length; index++) {
              Response.data[index].periodbanner = this.value.value.toString()
              Response.data[index].periodBack = this.value2.period
              Response.data[index].Convenio = this.value3.operator
              Response.data[index].iD_CALENDAR_PERMANENCIA = null
            }
            this.DLPrograms = Response.data
          } else {
            this.DLPrograms = [Response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    },

    searchFormpermanence () {
      debugger
      this.isNew2 = true
      document.getElementById('refNoData').classList.add('noShow')
      this.isNew = false
      let loader = this.$loading.show()
      var ListgetgetPermanence = IberoHelpers.getAllPermanenceProgram(
        this.$store,
        this.formSchModel,
        0
      )
      this.renderComponent1 = false

      ListgetgetPermanence.then((Response) => {
        if (Response.data === undefined || Response.data === '') {
          document.getElementById('refNoData').classList.remove('noShow')
        } else {
          if (Array.isArray(Response.data)) {
            this.DLPrograms = Response.data

            for (let index = 0; index < Response.data.length; index++) {
              Response.data[index].periodBack = this.value2.period
              Response.data[index].Convenio = this.value3.operator
              Response.data[index].iD_CALENDAR_PERMANENCIA = null
            }
          } else {
            this.DLPrograms = [Response.data]
          }
          debugger
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    },

    updatePeriod () {
      debugger
      this.limpiaref()
      if (this.CancelOption === '') {
        this.value2 = ''
        this.value3 = ''
      }
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then((results) => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()

            if (this.isNew2 === true) {
              this.formUpdModel.namProgram = ''
            }

            console.log(this.formUpdModel)
            var totalinf = IberoHelpers.insertPermanence(
              this.$store,
              this.formUpdModel

            )
            totalinf.then(Response => {
              this.renderComponent1 = false
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.UpdRExito = true
                resolve(true)
                this.value = ''
                this.value2 = ''
                this.value3 = ''
              }
              if (this.value3 === '') {
                this.form1 = true
              }
              this.$modal.hide('ProgramModal')
              // this.searchForm()
              loader.hide()
            })
          }
        })
      })
    },

    AddProgram () {
      this.limpiaref()
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then((results) => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()

            var totalinf = IberoHelpers.addPCalendarioA(
              this.$store,
              this.formUpdModel
            )
            totalinf.then((Response) => {
              this.renderComponent1 = false
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.addRExito = true
                resolve(true)
              }
              this.$modal.hide('ProgramModal')

              this.searchForm()
              loader.hide()
            })
          }
        })
      })
    },

    BuscarPeriodo () {
      debugger
      this.isNew2 = false
      this.UpdRExito = false
      this.value3 = ''
      if (this.CancelOption === '') {
        this.value2 = ''
        this.value3 = ''
      }
      if (this.value3 === '') {
        this.form1 = true
        this.ErrorDatos = true
      }
      var totalinfperiod = IberoHelpers.getPermanenceById(this.$store, this.value, 0)
      totalinfperiod.then(Response => {
        if ((Response.data === undefined) || (Response.data === '')) {
        } else {
          if (Array.isArray(Response.data)) {
            this.options2 = Response.data
          } else {
            console.log('errores')
          }
        }
      })
    },
    BuscarPeriodoNext () {
      debugger
      this.UpdRExito = false
      this.Ids = '2'
      this.isNew2 = false
      var banr = this.value.value.toString()
      var back = this.value2.period.toString()
      var PBack = back + '/' + banr
      this.value3 = ''
      this.form1 = true
      this.ErrorDatos = true
      var infperiod = IberoHelpers.getPermanenceByoperator(this.$store, PBack, 0)
      infperiod.then(Response => {
        if ((Response.data === undefined) || (Response.data === '')) {
        } else {
          if (Array.isArray(Response.data)) {
            this.options3 = Response.data
            debugger
          } else {
            console.log('errores')
          }
        }
      })
    },

    NewPeriod () {
      debugger
      this.Ids = '3'
      this.form1 = false
    },

    CancelUser () {
      this.CancelOption = 'true'
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('ProgramModal')
    },

    limpiaref () {
      this.addRExito = false
      this.UpdRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
      document.getElementById('refNoData').classList.add('noShow')
    },
    clearFields () {
      debugger
      this.formUpdModel.reference = 1
      this.formUpdModel.programa = ''
      this.formUpdModel.codigO_PROGRAMA = ''
      this.formUpdModel.renovacioN_ANTICIPADA = ''
      this.formUpdModel.staActive = ''
    },

    processData: function (dataInf, refdata) {
      debugger
      this.limpiaref()
      if (this.isNew2 === true) {
        this.formUpdModel.passw = '11'
        debugger
        this.formUpdModel.iD_CALENDAR_PERMANENCIA = this.value.value
        this.formUpdModel.iD_CALENDAR_PERMANENCIA_PROGRAM = dataInf.iD_CALENDAR_PERMANENCIA_PROGRAM
        this.formUpdModel.programa = dataInf.codigO_PROGRAMA
        this.formUpdModel.PBack = this.value2.period
        this.formUpdModel.CSTUDY = this.value3.operator
      } else {
        debugger
        this.formUpdModel.iD_CALENDAR_PERMANENCIA = this.value.value
        this.formUpdModel.programa = dataInf.codigO_PROGRAMA
        this.formUpdModel.iD_CALENDAR_PERMANENCIA_PROGRAM = dataInf.id
        this.formUpdModel.codigO_PROGRAMA = dataInf.programa
        this.formUpdModel.PBack = this.value2.period
        this.formUpdModel.CSTUDY = this.value3.operator
      }
      this.isNew = false
      if (dataInf.staActive === true) {
        this.formUpdModel.staActive = 1
      } else {
        this.formUpdModel.staActive = 0
      }
      this.formUpdModel.id = dataInf.id
      this.formUpdModel.reference = 1
      this.formUpdModel.renovacioN_ANTICIPADA = dataInf.renovacioN_ANTICIPADA

      IberoHelpers.forceRerender2(this)
      this.$modal.show('ProgramModal')
      this.BuscarPeriodo()
    },
  },
}
</script>

<style scoped>
.listPrograms {
  margin-top: 30px;
}

/* RESET */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* STYLING */
.container {
  max-width: 98%;
  min-width: 98%;
  margin: 10px auto;
  font-family: "Montserrat", sans-serif;
  color: #888;
}

/* Style the tabs */
.tabs {
  overflow: hidden;
  margin-left: 20px;
  margin-bottom: -2px;
}

.tabs ul {
  list-style-type: none;
  margin-left: 20px;
}

.tabs a {
  float: left;
  cursor: pointer;
  padding: 12px 24px;
  transition: background-color 0.2s;
  border: 1px solid #ccc;
  border-right: none;
  background-color: #f1f1f1;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
}
.tabs a:last-child {
  border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
  background-color: #a2273c;
  color: #fff;
}

/* Styling for active tab */
.tabs a.active {
  background-color: #fff;
  color: #a2273c;
  border-bottom: 2px solid #fff;
  cursor: default;
}

/* Style the tab content */
.tabcontent {
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  overflow-y: auto;
  height: 550px;
}

.botonPnrocess {
  text-align: center;
  margin-top: -10px;
  margin-bottom: 30px;
}

.noShow {
  display: none;
}

.refNoData {
  font-weight: bold;
  padding: 10px;
  padding-left: 20px;
  margin-top: 30px;
}

.listPrograms {
  padding: 20px;
}

.loginbtn {
  width: 90%;
}

.DataRoluser {
  padding: 30px !important;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #F65A6F;
}

.custom-control-label {
  cursor: pointer;
}

.statusPerson {
  padding-top: 50px;
}

.rolcontent {
  padding-top: 20px;
}
</style>